import React from "react";
import Accordion from "../Accordion";
import Item from "./Item";


function Child({menu, onClick}) {
    const {name, icon, label, route, id} = menu;
    let key = id || label || name.replaceAll(' ', '');
    return (
        <React.Fragment key={key}>
            <li className="nav-item" style={{ listStyle: "none" }}>
                <Accordion
                    eventKey={key}
                    className="nav-link font-size-sm text-truncate text-white"
                    style={{
                        borderRadius: "8px",
                        marginBottom: "4px",
                        padding: "8px 12px",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        cursor: "pointer",
                        border: "1px solid rgba(255,255,255,0.08)",
                        backgroundColor: "rgba(255,255,255,0.03)",
                        fontSize: "0.85rem",
                        fontWeight: "600",
                        letterSpacing: "0.2px",
                        textDecoration: "none",
                    }}>
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <div className="d-flex align-items-center" style={{ minWidth: 0, flex: 1 }}>
                            <div 
                              style={{ 
                                width: "28px",
                                height: "28px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "6px",
                                backgroundColor: "rgba(131, 193, 74, 0.15)",
                                border: "1px solid rgba(131, 193, 74, 0.2)",
                                flexShrink: 0,
                              }}
                            >
                              <i className={icon} style={{ fontSize: "0.9rem", color: "#83c14a" }}></i>
                            </div>
                            <span className="ms-2" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{label || name}</span>
                        </div>
                        <div 
                          className="p-1"
                          style={{
                            backgroundColor: "rgba(255,255,255,0.08)",
                            borderRadius: "5px",
                            width: "20px",
                            height: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                            marginLeft: "8px",
                          }}
                        >
                            <i className="bi bi-chevron-down" style={{ fontSize: "0.7rem", color: "#a8d97f" }}></i>
                        </div>
                    </div>
                </Accordion>
            </li>
            <Accordion.Collapse eventKey={key}>
                <ul 
                  className="navbar-nav ms-3 mb-2" 
                  style={{ 
                    borderLeft: "2px solid rgba(131, 193, 74, 0.2)", 
                    paddingLeft: "12px",
                    paddingTop: "2px",
                  }}
                >
                    {route.map((m, i) => {
                        return <Item key={i} menu={m} onClick={onClick}/>
                    })}
                </ul>
            </Accordion.Collapse>
        </React.Fragment>
    );
}


export default Child;